import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  // This implementation makes an assumtion that both
  // your video and button tags are siblings.

  const videoButton = $(node).findEl('button')
  const video = $(node).findEl('video')
  const videoTitle = $(node).attr('data-title')

  const togglePlay = async (event) => {
    if (video.paused) {
      try {
        video.ended ? video.load() : await video.play()
        if (window?.gtag && event?.type === 'click') {
          window.gtag('event', 'Video Start', {
            event_detail: videoTitle,
          })
        }
      } catch (err) {
        console.error(err)
      }
    } else if (event?.type === 'click' && video.paused === false) {
      video.pause()
      if (window?.gtag) {
        window.gtag('event', 'Video Pause', {
          event_detail: videoTitle,
        })
      }
    }

    $(videoButton).attr('aria-label', `${video.paused ? 'Play' : 'Pause'} Video`)
    $(videoButton).attr('aria-pressed', !video.paused)
  }

  if (videoButton && video) {
    $(videoButton).attr('aria-disabled', 'false')
    $(videoButton).on('click', togglePlay)
    $(video).on('ended', togglePlay)
    $(video).attr('playsinline', 'true')
  }
  video.loop ? togglePlay() : null

  return () => {
    $(videoButton).off('click', togglePlay)
    $(video).off('ended', togglePlay)
  }
})
